import React from 'react';
import CustomButton from '../button/CustomButton';
import CustomTooltip from '../tooltip/CustomTooltip';
import {
  CalendarDayPlusIcon,
  TooltipBody,
  TooltipHeader,
  TooltipHeaderIcon,
  TooltipPrimaryContent,
  TooltipSecondaryContent,
} from './components';

const SecondaryContentTooltip = ({
  primaryContent,
  secondaryContent,
  onEditClick = () => {},
  onDeleteClick = () => {},
  hideActions,
  isFirstRow,
}) => (
  <CustomTooltip
    below={isFirstRow}
    style={{
      width: '16rem',
      height: 'fit-content',
      left: '50%',
      marginLeft: `-8rem`,
      // First row opens DOWNWARD; otherwise the upward tooltip is clipped by the
      // calendar's scroll container (overflow-y: auto) at the top edge.
      ...(isFirstRow ? { top: '100%' } : { bottom: '100%' }),
      background: '#FAFAFA',
      boxShadow: '0px 2px 4px #d0d0c8',
      padding: '0.8rem 0.6rem 2.4rem',
    }}
  >
    {!hideActions && (
      <TooltipHeader>
        <TooltipHeaderIcon edit onClick={onEditClick} />
        <TooltipHeaderIcon onClick={onDeleteClick} />
      </TooltipHeader>
    )}
    <TooltipBody>
      <TooltipPrimaryContent>{primaryContent}</TooltipPrimaryContent>
      <TooltipSecondaryContent>{secondaryContent}</TooltipSecondaryContent>
    </TooltipBody>
  </CustomTooltip>
);

export default SecondaryContentTooltip;
